<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-12">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">CNA na Escola</a></li>
                            <li>Instituições de Ensino</li>
                        </ul>
                    </section>

                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Editar Instituição de Ensino</b></h2>
                    </div>


                    <b-tabs>

                        <b-tab title="Instituição de Ensino">
                            <br />
                            <form-edit :id="instituicaoEnsinoId" @on-saved="onSaved" @on-back="onBack()" />
                        </b-tab>

                        <b-tab title="Modalidade">
                            <br />
                            <modalidade-instituicao v-if="dialogLoad" :id="instituicaoEnsinoId" />
                        </b-tab>
                        <b-tab title="Instituição de Ensino Estágio">
                            <br />
                            <instituicao-ensino-estagio  v-if="dialogLoad" :id="instituicaoEnsinoId" />
                        </b-tab>
                    </b-tabs>


                </div>
            </div>
        </section>


    </main>

</template>
<script>

    import formEdit from './form-edit'
    import modalidadeInstituicao from './instituicaoensinomodalidade'
    import instituicaoEnsinoEstagio from './instituicaoensinoestagio'

    export default {
        name: 'instituicaoensino-edit',
        components: { formEdit, modalidadeInstituicao, instituicaoEnsinoEstagio },
        data: () => ({
            instituicaoEnsinoId: 0,
            dialogLoad: false,
        }),
        methods: {
            onSaved: function (data) {
                if (data) this.$router.push({ path: '/instituicaoensino' });
            },
            onBack: function () {
                this.$router.go(-1);
            }
        },
        mounted() {
            this.instituicaoEnsinoId = + this.$route.params.id;
            this.dialogLoad = true;
        }
    };
</script>

